import React, { useEffect, useState } from "react";
import { Input, Button, Select, DatePicker, Spin, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";


const { Option } = Select;

const SearchFilters = ({
  onSearch,
  filtersList,
  onCancel,
  paymentModes,
  isloading,
  locations
}) => {
  const isMobile = useIsMobile();



  const initialFilters = Array.isArray(filtersList)
    ? filtersList.reduce((acc, filter) => {
      acc[filter] = ""; // Default value for each filter
      return acc;
    }, {})
    : {};

  console.log(initialFilters, "initial filters");
  const [filters, setFilters] = useState(initialFilters);

  // const handleSearch = () => {
  //   const formattedFilters = {};

  //   console.log(filters, "@@@@@@@");
  //   // Iterate through filters and only add those with a value
  //   Object.keys(filters).forEach((key) => {
  //     if (filters[key]) {
  //       formattedFilters[key] = filters[key];
  //     }
  //   });

  //   console.log("Formatted Filters:", formattedFilters);
  //   onSearch(formattedFilters);
  // };

  const handleFilterChange = (key, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: value,
    }));
  };
  const handleSearch = () => {
    const formattedCreatedAt = filters.created_at
      ? dayjs(filters.created_at).format("YYYY-MM-DD")
      : null;

    let is_active = filters.is_active;
    if (is_active === "true") is_active = true;
    else if (is_active === "false") is_active = false;
    else is_active = undefined;

    onSearch({
      ...filters,
      created_at: formattedCreatedAt,
      is_active,
    });
  };


  const handleCancel = async () => {
    setFilters({

    });
    await onCancel();
  };
  // const handleCancel = async () => {

  //   // Reset all filters to the initial state
  //   const resetFilters = filtersList?.reduce((acc, filter) => {
  //     acc[filter] = ""; // Reset filter value to empty string
  //     return acc;
  //   }, {});

  //   setFilters(resetFilters); // Set the filters to initial reset state
  //   console.log(resetFilters , 'resetfil');
  //   await onCancel(); // Fetch data with the reset filters
  //   if (resetFilters) {
  //     message.success("resetr")
  //     await fetchData();
  //   }
  // };

  const renderFilter = (filter) => {
    // Default filter configuration
    const defaultConfig = {
      component: Input,
      props: {
        placeholder: `Filter by ${filter
          .split("_")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}`,
        style: { width: isMobile ? "80vw" : 200 },
        value: filters[filter],
        onChange: (e) => handleFilterChange(filter, e.target.value),
      },
    };

    // Special case configurations
    const filterConfigs = {
      email: {
        component: Input,
        props: {
          placeholder: "Filter by Email",
          style: { width: isMobile ? "80vw" : 200 },
          value: filters.email || "",
          onChange: (e) => handleFilterChange("email", e.target.value),
        },
      },
      username: {
        component: Input,
        props: {
          placeholder: "Filter by Username",
          style: { width: isMobile ? "80vw" : 200 },
          value: filters.username || "",
          onChange: (e) => handleFilterChange("username", e.target.value),
        },
      },
      locations: {
        component: Select,
        props: {
          mode: "multiple",
          placeholder: "Select Locations",
          style: { width: isMobile ? "80vw" : 200, textAlign: "left" },
          value: filters.locations || [],
          onChange: (value) => handleFilterChange("locations", value),
          optionLabelProp: "children",
        },
        options: Array.isArray(locations)
          ? locations.map((loc) => ({ value: loc.uid, label: loc.location }))
          : [],
      },
      is_active: {
        component: Select,
        props: {
          placeholder: "Active",
          style: { width: isMobile ? "80vw" : 200, textAlign: "left" },
          value:
            filters.is_active === undefined || filters.is_active === ""
              ? undefined
              : String(filters.is_active),
          onChange: (value) => handleFilterChange("is_active", value),
        },
        options: [
          { value: "true", label: "Yes" },
          { value: "false", label: "No" },
        ],
      },
      created_at: {
        component: DatePicker,
        props: {
          style: { width: isMobile ? "80vw" : 200, textAlign: "left" },
          placeholder: "Created At",
          value: filters.created_at ? dayjs(filters.created_at) : null,
          onChange: (value) => handleFilterChange("created_at", value),
        },
      },
    };

    // Only allow email, username, locations, is_active, and created_at filters
    if (!['email', 'username', 'locations', 'is_active', 'created_at'].includes(filter)) return null;

    // Get the configuration for this filter, or use default
    const config = filterConfigs[filter] || defaultConfig;
    const Component = config.component;

    // For Select components with options
    if (config.options) {
      return (
        <Component {...config.props}>
          {config.options.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Component>
      );
    }

    // For other components
    return <Component {...config.props} />;
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{ background: "#eceff1", padding: "20px", borderRadius: "8px" }}>
        {isloading ? (
          <Spin />
        ) : (
          <div
            style={{
              marginBottom: 16,
              display: "flex",
              flexWrap: "wrap",
              gap: "28px",
              // justifyContent: "space-between",
              alignItems: "flex-end",
              width: "100%",
            }}>
            {filtersList?.map((filter) => (
              <div key={filter} style={{}}>
                {renderFilter(filter)}
                {console.log(filtersList, "filters list afetr update")}
                {console.log(filter, "filte list afetr update")}
              </div>
            ))}

            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "flex-end",
                alignContent: "flex-end",
                alignItems: "flex-end",
                position: "relative",
                right: isMobile ? "0" : "10px",
                flexDirection: isMobile ? "column" : "row",
                width: "100%",
              }}>
              <Button
                type="primary"
                style={{
                  width: isMobile ? "80vw" : 140,
                  background: "#040724",
                }}
                icon={<SearchOutlined />}
                onClick={handleSearch}>
                Search
              </Button>
              <Button
                style={{ width: isMobile ? "80vw" : 140 }}
                type="default"
                onClick={handleCancel}>
                Reset
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchFilters;
